export default "__VITE_ASSET__3ybrxCjq__"